// Phone Admin hub — the summary sheet (v1 openSummary): the whole week at a glance
// plus the doorways to Job Database, History, Backup and sign-out.
import { downloadBackup } from '../../lib/backup';
import { signOutDevice } from '../../state/admin';
import { showHistory, showHubSheet, showJobsDb } from '../../state/adminUi';
import { hubStats } from '../../state/hubstats';
import { week } from '../../state/schedule';
import { AdminSheet } from './AdminSheet';
import {
  Activity,
  ArchiveList,
  ByDay,
  ByTech,
  Kpis,
  People,
  ProgressBar,
  SectionTitle,
} from './HubBlocks';

export function AdminHubSheet() {
  const close = () => (showHubSheet.value = false);
  const s = hubStats.value;
  const w = week.value;

  return (
    <AdminSheet
      title="Admin hub"
      sub={w ? `${w.weekOf} · ${s.done}/${s.total} complete` : undefined}
      onClose={close}
      tall
      testId="admin-hub-sheet"
    >
      <button
        class="btn-ghost mb-3 w-full"
        data-testid="hub-sheet-jobs-db"
        onClick={() => {
          close();
          showJobsDb.value = true;
        }}
      >
        Job Database
      </button>

      <Kpis s={s} />
      <ProgressBar s={s} />

      <SectionTitle>By day</SectionTitle>
      <ByDay s={s} />
      <SectionTitle>By technician</SectionTitle>
      <ByTech s={s} />
      <SectionTitle>Latest activity</SectionTitle>
      <Activity s={s} limit={8} />
      <SectionTitle>People</SectionTitle>
      <People />
      <SectionTitle>Archived weeks</SectionTitle>
      <ArchiveList onPick={close} />

      <div class="mt-4 space-y-2 border-t border-slate-100 pt-3">
        <button
          class="btn-ghost w-full"
          onClick={() => {
            close();
            showHistory.value = true;
          }}
        >
          History
        </button>
        <button class="btn-ghost w-full" onClick={() => void downloadBackup()}>
          Download backup
        </button>
        <button
          class="tap w-full rounded-xl px-4 py-2.5 font-semibold text-slate-500"
          onClick={() => {
            if (confirm('Sign out on this device? You will need an access code to get back in.'))
              void signOutDevice();
          }}
        >
          Sign out on this device
        </button>
      </div>
    </AdminSheet>
  );
}
